import React from 'react';

import { fixUrl } from '../../util/urlHelpers';

const NewsLink = (props) => {
  const {
    className,
    link,
    children,
  } = props;

  const newsLink = fixUrl(link);

  return (
    <a
      className={className}
      target='_blank'
      href={newsLink}
    >
      {children}
    </a>
  );
};

export default NewsLink;
